export default "__VITE_ASSET__wxjAOI5L__"